import { Spin } from 'antd';
import type React from 'react';
import { useEffect } from 'react';
import { useMatch } from 'react-router-dom';

import { Layout } from 'src/components/layout/layout';
import { Route } from 'src/constants';
import { useIsUserChecked, useUserActions } from 'src/hooks/data/user';
import { Router } from 'src/router';

import './app.css';

export const App: React.FC = () => {
  const isCalculatorRoute = !!useMatch(Route.CALCULATOR);
  const isUserChecked = useIsUserChecked();
  const { getUser } = useUserActions();

  useEffect(() => {
    if (!isCalculatorRoute && !isUserChecked) {
      getUser();
    }
  }, [isCalculatorRoute, isUserChecked, getUser]);

  if (!isCalculatorRoute && !isUserChecked) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Spin />
      </div>
    );
  }

  return (
    <Layout>
      <Router />
    </Layout>
  );
};
